export * from "./scopes-item";

